import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Layout, message, Spin, Menu, Button } from 'antd';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import DeviceList from './components/DeviceList';
import InstalledAppsList from './components/InstalledAppsList';
import APKList from './components/APKList';
import CommandHistory from './components/CommandHistory';
import OperationLogs from './components/OperationLogs';
import api from './utils/api';
import './App.css';

const { Header, Content, Sider } = Layout;

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState('dashboard');
  const navigate = useNavigate();

  useEffect(() => {
    const validateToken = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        await api.get('/auth/verify');
        setIsLoggedIn(true);
      } catch (error) {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setIsLoggedIn(true);
    navigate('/dashboard');
    message.success('登录成功');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    navigate('/login');
    message.success('已退出登录');
  };

  const menuItems = [
    { key: 'dashboard', label: '仪表盘', path: '/dashboard' },
    { key: 'devices', label: '设备管理', path: '/devices' },
    { key: 'apks', label: 'APK管理', path: '/apks' },
    { key: 'commands', label: '指令历史', path: '/commands' },
    { key: 'logs', label: '操作日志', path: '/logs' },
  ];

  const handleMenuClick = ({ key }) => {
    setSelectedKey(key);
    const item = menuItems.find(i => i.key === key);
    if (item) {
      navigate(item.path);
    }
  };

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div className="logo">
          <h2>{collapsed ? 'XR' : 'XRKRoot'}</h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0 }}>
            {menuItems.find(i => i.key === selectedKey)?.label || '仪表盘'}
          </h2>
          <Button type="primary" onClick={handleLogout}>
            退出登录
          </Button>
        </Header>
        <Content style={{ margin: '16px' }}>
          <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/devices" element={<DeviceList />} />
              <Route path="/devices/:deviceId/apps" element={<InstalledAppsList />} />
              <Route path="/apks" element={<APKList />} />
              <Route path="/commands" element={<CommandHistory />} />
              <Route path="/logs" element={<OperationLogs />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
